"use client"
import { Box } from "@quintoandar-tokko/jopijs";
import style from "./calendarFormError.module.scss"

export default function CalendarFormError({ children }) {
  return (
    <Box className={style.calendarFormError}>
      <Box as="span" className={style.calendarFormErrorText}>
        {children}
      </Box>
    </Box>
  );
}
